import { render, staticRenderFns } from "./ehc-property-card.vue?vue&type=template&id=c8cfa72a&scoped=true"
import script from "./ehc-property-card.vue?vue&type=script&lang=js"
export * from "./ehc-property-card.vue?vue&type=script&lang=js"
import style0 from "./ehc-property-card.vue?vue&type=style&index=0&id=c8cfa72a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cfa72a",
  null
  
)

export default component.exports